import React from "react";

const ColorField = ({ label, name, value, onChange }) => {
  const color = value || "#000000";

  return (
    <div className="flex flex-col gap-2">
      <label className="text-sm font-medium text-[#17171C]">{label}</label>

      <div className="flex items-center gap-2">
        
        {/* Color Preview Box */}
        <label className="relative h-12 w-12 rounded-lg overflow-hidden cursor-pointer border border-[#E4E4E7]">
          <span
            className="absolute inset-0"
            style={{ backgroundColor: color }}
          />
          <input
            type="color"
            name={name}
            value={color}
            onChange={onChange}
            className="absolute inset-0 opacity-0 cursor-pointer"
          />
        </label>

        {/* Hex Input */}
        <input
          type="text"
          name={name}
          value={value || ""}
          onChange={onChange}
          maxLength={7}
          placeholder="#000000"
          className="h-12 w-[200px] !rounded-xl border !border-[#E4E4E7] px-4 text-sm text-[#17171C] focus:!border-[#17171C] focus:!shadow-none focus:!ring-0 outline-none"
        />
      </div>
    </div>
  );
};

export default ColorField;